"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureProvider = exports.useFeatureBase = exports.useIsLoading = void 0;
var react_1 = __importStar(require("react"));
var feature_flag_client_1 = require("./feature-flag-client");
var FeatureFlagContext = (0, react_1.createContext)(feature_flag_client_1.defaultClient);
function useIsLoading(isAnonymous) {
    var client = (0, react_1.useContext)(FeatureFlagContext);
    var _a = (0, react_1.useState)(client.clientInitialized), initialized = _a[0], setInitialized = _a[1];
    var _b = (0, react_1.useState)(client.clientIdentified), identified = _b[0], setIdentified = _b[1];
    var _c = (0, react_1.useState)(client.clientInitializationErrored), initializationErrored = _c[0], setInitializationErrored = _c[1];
    var _d = (0, react_1.useState)(client.clientIdentificationErrored), identificationErrored = _d[0], setIdentificationErrored = _d[1];
    (0, react_1.useEffect)(function () { return client.onInitializeEvent(setInitialized); }, [client]);
    (0, react_1.useEffect)(function () { return client.onIdentifiedEvent(setIdentified); }, [client]);
    (0, react_1.useEffect)(function () { return client.onInitializationErroredEvent(setInitializationErrored); }, [client]);
    (0, react_1.useEffect)(function () { return client.onIdentificationErroredEvent(setIdentificationErrored); }, [client]);
    if (initializationErrored || identificationErrored) {
        return false;
    }
    return !client || !initialized || (!identified && !isAnonymous);
}
exports.useIsLoading = useIsLoading;
function useFeatureBase(flagName, isAnonymous, defaultValue, options) {
    var client = (0, react_1.useContext)(FeatureFlagContext);
    var isLoadingFeatureFlags = useIsLoading(isAnonymous);
    var hasOverride = client.hasOverride(flagName);
    var isLoading = !hasOverride && isLoadingFeatureFlags;
    var value = isLoading && !hasOverride ? defaultValue : client.getVariantNoTrack(flagName, defaultValue);
    (0, react_1.useEffect)(function () {
        if (!isLoading && !hasOverride && (options === null || options === void 0 ? void 0 : options.shouldTrack) === true) {
            client.trackVariant(flagName, value);
        }
    }, [flagName, value, isLoading, hasOverride, options === null || options === void 0 ? void 0 : options.shouldTrack]);
    return [value, isLoading];
}
exports.useFeatureBase = useFeatureBase;
function FeatureProvider(props) {
    return (react_1.default.createElement(FeatureFlagContext.Provider, __assign({ value: feature_flag_client_1.defaultClient }, props), props.children));
}
exports.FeatureProvider = FeatureProvider;
